import React, { Component } from "react";

import QuotationRow from "./QuotationRow";

//import { withStyles } from '@material-ui/core/styles';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableFooter from '@material-ui/core/TableFooter';
import TablePagination from '@material-ui/core/TablePagination';
import { withTranslation } from 'react-i18next';

class QuotationList extends Component {
	constructor(props) {
        super(props);
		this.state= {
			page: 0,
			rowsPerPage: 25,
		}
		
		this.handleFirstPageButtonClick=this.handleFirstPageButtonClick.bind(this);
		this.handleBackButtonClick=this.handleBackButtonClick.bind(this);
		this.handleNextButtonClick=this.handleNextButtonClick.bind(this);
		this.handleLastPageButtonClick=this.handleLastPageButtonClick.bind(this);
		this.handleChangePage=this.handleChangePage.bind(this);
		this.handleChangeRowsPerPage=this.handleChangeRowsPerPage.bind(this);
		this.orderProjectsDESC=this.orderProjectsDESC.bind(this);
	}
	
	handleFirstPageButtonClick(event) {
		this.setState({page: 0});
	}
	
	handleBackButtonClick(event) {
		this.setState({page: this.state.page-1});
	}
	
	handleNextButtonClick(event) {
		this.setState({page: (this.state.page+1 > Math.max(0, Math.ceil(Object.keys(this.props.quotations).length / this.state.rowsPerPage) - 1)) ? this.state.page : this.state.page+1});
	}
	
	handleLastPageButtonClick(event) {
		this.setState({page: Math.max(0, Math.ceil(Object.keys(this.props.quotations).length / this.state.rowsPerPage) - 1)});
	}
  
	handleChangePage(event, newPage) {
		this.setState({page: newPage});
	}
	
	handleChangeRowsPerPage(event) {
		this.setState({ rowsPerPage: parseInt(event.target.value, 10),
						page: 0
		});
	}
	
	orderProjectsDESC(a, b){
		return ( this.props.quotations[b].id - this.props.quotations[a].id );
	}

	render() {
		var user;
		const { t } = this.props;
    	const rows = [];
		if(this.props.quotations){
			var keys = Object.keys(this.props.quotations).sort(this.orderProjectsDESC);
			if(keys.length>0){
				//console.log(keys);
				for (var j = this.state.rowsPerPage*this.state.page; (j < (this.state.rowsPerPage*(this.state.page+1))) && (j<keys.length); j++) {
					var quotation = this.props.quotations[keys[j]];
					//if(quotation.orders[0].user && this.props.users[quotation.user] && this.props.customers[this.props.users[quotation.user].customer] && this.props.langPairs[quotation.langPair]){
					if(quotation.orders.length>0  && this.props.orders[quotation.orders[0]] && this.props.orders[quotation.orders[0]].user && this.props.users[this.props.orders[quotation.orders[0]].user] && this.props.customers[this.props.users[this.props.orders[quotation.orders[0]].user].customer] && this.props.langPairs[this.props.orders[quotation.orders[0]].langPair]){
						rows.push(
							<QuotationRow
								key={quotation.id}
								id={quotation.id}
								customer={this.props.customers[this.props.users[this.props.orders[quotation.orders[0]].user].customer].name}
								code={quotation.code}
								description={quotation.name}
								accessToken={this.props.accessToken}
								recvd={this.props.orders[quotation.orders[0]].date}
								state={this.props.orders[quotation.orders[0]].state}
								actions={this.props.quotationActions}
								quotationId={quotation.quotation}
								deleteProject = {this.props.deleteProject}
								processInstanceId={quotation.processInstanceId}/>
						);
					}else{
//						console.log("SALTA projecte: "+quotation.id);
//						console.log(this.props);
					}
				}
			}
		}
		let rowsPerPage=25;
		let page=0;
		return (
		<div className="content">
		  <Table className="lst">
		    <TableHead>
		      <TableRow>
				<TableCell>{t('customer')}</TableCell>
				<TableCell>{t('code')}</TableCell>
		        <TableCell>{t('document')}</TableCell>
				<TableCell>{t('recived')}</TableCell>
				<TableCell>{t('state')}</TableCell>
				<TableCell>{t('accept')}</TableCell>
				<TableCell>PDF / XLSX</TableCell>
				<TableCell>{t('del')}</TableCell>
		      </TableRow>
		    </TableHead>
		    <TableBody>{rows}</TableBody>
		    <TableFooter>
              <TableRow>
                <TablePagination
                  colSpan={3}
                  count={rows.length}
				  rowsPerPage={this.state.rowsPerPage}
                  page={this.state.page}
                  onChangePage={this.handleChangePage}
                  onChangeRowsPerPage={this.handleChangeRowsPerPage}
//                  ActionsComponent={TablePaginationActionsWrapped}
                />
              </TableRow>
            </TableFooter>
		  </Table>
		</div>
		);
  }
};

export default withTranslation()(QuotationList);